import { Action } from '@anm/components/ActionsDropdown';
import { Item } from '@anm/components/ActionsDropdown/ActionItem';
import Tooltip from '@anm/components/Tooltip';
import { getLinkTarget, getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { FC } from 'react';
import styled from 'styled-components'

import { ActionItemWrapper, ActionTooltip, ActionTooltipWrapper, RelativeWrapper } from '../streamVideo/Wrapper';

type CommonProps = {
  publishUrl: string;
  isUpgradeTooltip: boolean;
};

type DownloadVideoTooltipProps = CommonProps & {
  action: Action;
  handler?: () => void;
};

type DownloadActionProps = DownloadVideoTooltipProps & {
  canStreamVideo: boolean;
};

const ItemWrapper = styled.div`
  width: inherit;
`

const createUpgradeLink = () => <a {...getUpgradeLinkProps()}>upgrade</a>;

const createPublishLink = (url: string) => (
  <a href={url} target={getLinkTarget()}>
    Publish it in the editor
  </a>
);

const getTooltipText = ({ isUpgradeTooltip, publishUrl }: CommonProps) =>
  isUpgradeTooltip ? (
    <p>
      Please {createUpgradeLink()} <br /> to download video
    </p>
  ) : (
    <p>
      This video has not been published yet. <br /> {createPublishLink(publishUrl)} to download it.
    </p>
  );

const DownloadTooltipContent: FC<CommonProps> = props => <ActionTooltip>{getTooltipText(props)}</ActionTooltip>;

const DownloadVideoActionWithTooltip: FC<DownloadVideoTooltipProps> = ({
  action,
  publishUrl,
  isUpgradeTooltip,
  handler
}) => (
  <ActionTooltipWrapper>
    <Tooltip
      delayShow={500}
      direction="top-center"
      renderContent={() => <DownloadTooltipContent {...{ publishUrl, isUpgradeTooltip }} />}
    >
      <ActionItemWrapper>
        <Item {...action} {...{ handler }} disabled={true} />
      </ActionItemWrapper>
    </Tooltip>
  </ActionTooltipWrapper>
);

const DownloadVideoAction: FC<DownloadActionProps> = ({
  action,
  handler,
  canStreamVideo,
  isUpgradeTooltip,
  publishUrl
}) => (
  <RelativeWrapper>
    {canStreamVideo && !isUpgradeTooltip ? (
      <ItemWrapper onClick={handler}>
        <Item {...action}  />
      </ItemWrapper>
    ) : (
      <DownloadVideoActionWithTooltip {...{ action, publishUrl, isUpgradeTooltip }} />
    )}
  </RelativeWrapper>
);

export default DownloadVideoAction;
